module.exports = __webpack_public_path__ + "static/img/4.6be56d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/4.jpg
// module id = FdY6
// module chunks = 0